import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
export default function PopularMaterials({ materials, generatePath, }) {
    const { t } = useTranslation();
    if (materials?.length === 0) {
        return null;
    }
    return (_jsx("diamond-enter", { type: "fade-in-up", children: _jsxs("locator-bordered-list", { size: "sm", className: "diamond-spacing-top-lg", children: [_jsx("h3", { children: t('common.popularSearches') }), _jsx("nav", { children: _jsx("ul", { children: materials.map((material) => (_jsx("li", { children: _jsx(Link, { to: generatePath(material), children: material.name }) }, material.id))) }) })] }) }));
}
